import { render, staticRenderFns } from "./DebtorBestWorstAnalysisStatistic.vue?vue&type=template&id=89114266&scoped=true"
import script from "./DebtorBestWorstAnalysisStatistic.vue?vue&type=script&lang=ts"
export * from "./DebtorBestWorstAnalysisStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89114266",
  null
  
)

export default component.exports